import React, { useState } from 'react'
import {
    Box,
    useTheme,
    Typography,
    Grid,
    useMediaQuery,
    makeStyles,
} from '@material-ui/core';

import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import { useCalculator } from '../../state/calculatorState';
import { dataHistoric, dataProjection } from '../../data/InflationRates'
import { PriceIntegerFormat } from '../../components/common/customFormatters'
import {
    StyledTextField, StyledFormControl, CustomDatePicker,
} from '../../components/common/CustomComponents'
import { InflationIncome } from './InflationIncome'
import { MONTH_NAMES_SHORT } from '../../constants';
import { parseInputValue, monthsBetweenDates } from '../../utils/utils'
import { formatMoney, isUndefined } from '../../core/calculatorUtils';

// save all lookups of cpi for a given date
const cpiHash = new Map()

function calculateMonthlyInterest(value, rate) {
    var interest = (rate / 100);
    return value * interest;
}

function dateToString(date) {
    return `${MONTH_NAMES_SHORT[date.getMonth()]} ${date.getFullYear()}`
}

function stringToDate(str) {
    // string in the form of MMM YYYY
    // eg Dec 2019
    return new Date(Date.parse(`1 ${str.toString()}`))
}


const useStyles = makeStyles((theme) => {
    return {

        //
        mobileInput: {
            '& .MuiFilledInput-input': {
                paddingBottom: 0,
                height: 48,
            },
            '& .MuiInput-input': {
                height: 50,
                paddingBottom: 0,
            },
        },


        defaultInput: {
            '& .MuiInputBase-input': {
                //height: '1.2em'
            }
        },

    }
})


function getCPI(checkDate) {

    if (isUndefined(dataHistoric)) return { cpi: 0, month: 0 }
    if (isUndefined(dataProjection)) return { cpi: 0, month: 0 }

    const checkedDateString = dateToString(checkDate)
    const alreadyMatched = cpiHash.get(checkedDateString)
    if (alreadyMatched !== undefined) {
        return alreadyMatched
    }

    let month = undefined;
    let cpi = undefined;
    let d;

    // search through the historic record
    if (checkDate < stringToDate(dataHistoric[dataHistoric.length - 1].date)) {
        for (let i = 0; i < dataHistoric.length; i++) {
            d = dataHistoric[i]
            let date = d.date || "Dec 2021"
            date = stringToDate(date)
            if (checkDate < date) {
                month = d.date || "Dec 2021"
                cpi = Number(d.rate) / 12;
                cpiHash.set(checkedDateString, { cpi, month })
                return { cpi, month }
            }
        }
    }
    for (let i = 0; i < dataProjection.length; i++) {
        d = dataProjection[i]
        let date = d.date || "Dec 2021"
        date = stringToDate(date)
        if (checkDate < date) {
            month = d.date || "Dec 2021"
            cpi = Number(d.rate) / 12;
            cpiHash.set(checkedDateString, { cpi, month })
            return { cpi, month }
        }
    }
    return { cpi: 0, month }
}


function calcualteInflation(income, fromDate, toDate, labelsCount) {

    if (isUndefined(dataHistoric) || isUndefined(dataProjection)) return false

    const incomeData = {
        current: income,
    }
    // fromDate is a date object!!
    // set curentDate to first of the current month
    let currentDate = new Date()
    currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

    // tempDate is a date that is incremented monthly and steps through the CPI data
    let tempDate = new Date(fromDate.getTime());

    // inflation figures are calculated every 6 months
    let endDate = dataProjection[dataProjection.length - 1]

    endDate = endDate.date
    endDate = stringToDate(endDate)
    // add 1 month to perform calcultion on  end month
    //endDate = new Date(endDate.setMonth(endDate.getMonth() + 1));

    let adjusted = income;
    let effective = income;
    let monthlyInflation;

    // -----------------------------------------
    // comparison inflation
    // -----------------------------------------
    if (tempDate < toDate) {
        while (tempDate < toDate) {
            // add 1 month
            tempDate = new Date(tempDate.setMonth(tempDate.getMonth() + 1));
            let cpi = getCPI(tempDate)
            monthlyInflation = cpi.cpi;
            adjusted += calculateMonthlyInterest(adjusted, monthlyInflation);
            effective -= calculateMonthlyInterest(effective, monthlyInflation);
        }
    }

    // Have now calculated data up until today
    // add these to the data obj
    incomeData.adjusted = adjusted
    incomeData.effective = effective

    ///   Calculate projection
    incomeData.projection = []

    // reset temp date
    tempDate = new Date(fromDate.getTime());
    endDate = toDate

    let monthsTotal = monthsBetweenDates(fromDate, toDate)
    let monthsActual = monthsBetweenDates(fromDate, currentDate)
    let monthSpan = Math.floor(monthsTotal / labelsCount)

    // future inflation projection
    // increment an array of 'projection' objs everytime there is a rate rise
    adjusted = income;
    effective = income;

    if (tempDate < endDate) {
        // zero date
        incomeData.projection.push({
            date: dateToString(tempDate),
            forecast: (tempDate >= currentDate),
            skip: false,
            effective,
            adjusted,
        })

        let monthIndex = 1
        while (tempDate < endDate) {

            // add 1 month
            tempDate = new Date(tempDate.setMonth(tempDate.getMonth() + 1));
            let tempDateString = dateToString(tempDate)
            let isForecst = tempDate >= currentDate ? true : false;
            let isNow = monthIndex === monthsActual

            let cpi = getCPI(tempDate)
            monthlyInflation = cpi.cpi;

            adjusted += calculateMonthlyInterest(adjusted, monthlyInflation);
            effective -= calculateMonthlyInterest(effective, monthlyInflation);

            let showLabel = false
            showLabel = monthIndex % monthSpan === 0 ? true : false;
            // skip any months too close the start date
            showLabel = monthIndex < (monthSpan) ? false : showLabel
            // skip any month too clode to the current date marker
            showLabel = monthIndex > (monthsActual - monthSpan) && monthIndex < (monthsActual - monthSpan) ? false : showLabel
            // skip months too close to end
            showLabel = monthIndex > (monthsTotal - monthSpan) ? false : showLabel
            // show current date
            showLabel = isNow ? true : showLabel
            // show last month
            showLabel = monthIndex === monthsTotal ? true : showLabel

            incomeData.projection.push({
                date: isNow ? "NOW" : tempDateString,
                forecast: isForecst,
                skip: !showLabel,
                effective,
                adjusted,
            })

            monthIndex++;
        }
    }
    //

    // reduce the number of porjection dates 



    return incomeData;
}



export const InflationCalculator = () => {
    const theme = useTheme();
    const classes = useStyles();

    const sm = useMediaQuery(theme.breakpoints.down('sm'));
    const labelsCount = sm ? 2 : 5

    //income
    const today = stringToDate(dateToString(new Date()))
    const [{ income: salary, salary: inputSalary },] = useCalculator();
    const [income, setIncome] = useState(salary.a);
    const [payriseStartDate, setPayrise] = useState(new Date(new Date().getFullYear(), 0, 1));
    const [payriseComparisonDate, setComparison] = useState(today);
    //
    const [masterSalary, setMasterSalary] = useState(inputSalary);
    if (masterSalary !== inputSalary) {
        setMasterSalary(inputSalary);
        setIncome(salary.a);
    }

    if (isUndefined(dataHistoric) || isUndefined(dataProjection)) return false
    // end date of proected data
    const endDate = stringToDate(dataProjection[dataProjection.length - 1].date)


    const updatePayriseDate = (date) => {
        const newDate = date < minDate ? minDate : date
        setPayrise(stringToDate(dateToString(newDate)));
    }

    const updateComparisonDate = (date) => {
        let newDate = date < payriseStartDate ? payriseStartDate : date
        setComparison(stringToDate(dateToString(newDate)));
    }


    const modifyIncomeInput = (event) => {
        setIncome(parseInputValue(event.target.value));
    }


    let minDate = dataHistoric[0] ? stringToDate(dataHistoric[0].date) : new Date()
    let maxDate = new Date()

    let incomeData = calcualteInflation(income, payriseStartDate, payriseComparisonDate, labelsCount)
    //const endData = incomeData.projection[incomeData.projection.length - 1]
    const comparisonAdjusted = incomeData.adjusted - incomeData.current
    const comparisonEffective = incomeData.effective - incomeData.current
    const comparisonAdjustedPercent = (comparisonAdjusted / incomeData.current) * 100


    return (
        <>
            <Box style={{ padding: '0px 20px', position: "relative" }}>

                <Grid container >

                    <Grid item xs={4}>
                        <StyledTextField
                            className={sm ? classes.mobileInput : classes.defaultInput}
                            label={"Annual Salary"}
                            fullWidth
                            value={income > 0 ? income : null}
                            defaultValue={0}
                            variant="filled"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                inputComponent: PriceIntegerFormat,
                                inputMode: "numeric",
                                inputProps: {
                                    inputMode: "numeric",
                                },
                            }}
                            onChange={modifyIncomeInput}
                            id={"Annual Salary: inflation"}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <StyledFormControl
                            variant="filled"
                            fullWidth
                            style={{ paddingLeft: 10, paddingRight: 10 }}
                            className={sm ? classes.mobileInput : classes.defaultInput}
                        >

                            <CustomDatePicker
                                // autoOk
                                label={"Date of last pay rise"}
                                id="Date of last pay rise"
                                aria-label="Date of last pay rise"
                                // disableFuture
                                value={payriseStartDate}
                                views={["year", "month"]}
                                format={"MMM YYYY"}
                                minDate={minDate}
                                maxDate={maxDate}
                                onChange={date => updatePayriseDate(date.toDate())}
                            />
                        </StyledFormControl>
                    </Grid>

                    <Grid item xs={4}>
                        <>
                            <StyledFormControl
                                variant="filled"
                                fullWidth
                                className={sm ? classes.mobileInput : classes.defaultInput}>
                                <CustomDatePicker
                                    // autoOk
                                    label={"Comparison Date"}
                                    id="comparison date"
                                    aria-label="Comparison Date"
                                    // disableFuture
                                    value={payriseComparisonDate}
                                    views={["year", "month"]}
                                    format={"MMM YYYY"}
                                    minDate={payriseStartDate}
                                    maxDate={endDate}
                                    onChange={date => updateComparisonDate(date.toDate())}
                                />
                            </StyledFormControl>
                        </>
                    </Grid>


                    <Grid item xs={4} style={{ backgroundColor: theme.palette.background.overlayFaint }} >
                        <Box style={{ padding: 10 }}>
                            <Typography variant="body1" style={{ fontSize: 14, }} >{`Between ${dateToString(payriseStartDate)} and ${dateToString(payriseComparisonDate)} inflation will have caused your salary to effectively fall by 
                $${formatMoney(Math.abs(comparisonEffective), 0)}. To maintain your real income, your salary should increase to $${formatMoney(incomeData.adjusted, 0)} or by ${comparisonAdjustedPercent.toFixed(2)}%`}</Typography>
                        </Box>
                    </Grid>


                    <Grid item xs={4} >
                        <Box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center" style={{ paddingLeft: 20, height: '100%' }}>
                            <Typography variant="h4" >{`$${formatMoney(income, 0)}`}</Typography>
                            <Typography variant="body2" >{`Income since ${dateToString(payriseStartDate)}`}</Typography>
                        </Box>
                    </Grid>


                    <Grid item xs={4} >

                        <Box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center" style={{ paddingLeft: 10, height: '100%' }}>

                            <Box display="flex" flexDirection="column" alignItems="center">

                                <Typography variant="h4" style={{ color: theme.palette.primary.main }}>{`$${formatMoney(incomeData.adjusted, 0)}`}</Typography>
                                <Box display="flex" flexDirection="row" alignItems="center" style={{marginTop:-10}}>
                                    <Typography variant="h4" style={{ fontSize: 12, color: theme.palette.primary.main }}> {comparisonAdjusted >= 0 ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />} </Typography>
                                    <Typography variant="h4" style={{ fontSize: 12, color: theme.palette.primary.main }}>{`$${formatMoney((Math.abs(comparisonAdjusted)), 0)}`}</Typography>
                                </Box>
                            </Box>
                            
                            <Typography variant="body2" style={{ color: theme.palette.primary.main }}>{`Inflation Adjusted Income`}</Typography>

                            <Box display="flex" flexDirection="column" alignItems="center" style={{ paddingTop: 10 }}>
                                <Typography variant="h4" style={{ color: theme.palette.secondary.main }}>{`$${formatMoney(incomeData.effective, 0)}`}</Typography>
                                <Box display="flex" flexDirection="row" alignItems="center" style={{marginTop:-10}}>
                                <Typography variant="h4" style={{ fontSize: 12, color: theme.palette.secondary.main }}> {comparisonEffective >= 0 ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />} </Typography>
                                <Typography variant="h4" style={{ fontSize: 12, color: theme.palette.secondary.main }}>{`$${formatMoney((Math.abs(comparisonEffective)), 0)}`}</Typography>
                                </Box>
                            </Box>


                            <Typography variant="body2" style={{ color: theme.palette.secondary.main }}>{`Effective Income`}</Typography>
                        </Box>
                    </Grid>

                </Grid>

                <Box style={{ paddingBottom: 10, paddingTop: 20 }}>
                    <InflationIncome data={incomeData} />
                </Box>
            </Box>
        </>
    )
}

export default InflationCalculator